export default {
  求和: 'Sum',
  不展示: 'Hide',
  不支持汇总: 'Not supported',
  数据汇总: 'Data summary'
};
